export interface RouteConfig {
  Android?: string;
  iOS?: string;
  Desktop?: string;
  default?: string;
  fallback?: string;
  androidFallback?: string;
  iOSFallback?: string;
  androidIntent?: boolean;
}

export interface RedirectConfig {
  [path: string]: RouteConfig;
}

export const redirectConfig: RedirectConfig = {
  "/invoices/create/redirect": {
    Android: "intent://add-invoice#Intent;scheme=esemie;package=com.esemie;end",
    iOS: "esemie://add-invoice", // Fixed: Use proper custom URL scheme
    Desktop: "https://app.esemie.io/invoices/createFreeform",
    androidFallback: "https://play.google.com/store/apps/details?id=com.esemie",
    iOSFallback: "https://apps.apple.com/app/id6504359243",
    default: "https://app.esemie.io/invoices/createFreeform",
    androidIntent: true,
  },
  "/subscription/redirect": {
    Android:
      "intent://subscription-stat#Intent;scheme=esemie;package=com.esemie;end",
    iOS: "esemie://subscription-stat", // Fixed: Use proper custom URL scheme instead of web URL
    Desktop: "https://app.esemie.io/settings?tab=subscription",
    androidFallback: "https://play.google.com/store/apps/details?id=com.esemie",
    iOSFallback: "https://apps.apple.com/app/id6504359243",
    default: "https://app.esemie.io/settings?tab=subscription",
    androidIntent: true,
  },
  "/inventories/:id/restock/redirect": {
    Android:
      "intent://restock-inventory#Intent;scheme=esemie;package=com.esemie;S.id={id};end",
    iOS: "esemie://restock-inventory?id={id}", // Fixed: Use proper custom URL scheme with parameters
    Desktop: "https://app.esemie.io/inventories/{id}/restock",
    androidFallback: "https://play.google.com/store/apps/details?id=com.esemie",
    iOSFallback: "https://apps.apple.com/app/id6504359243",
    default: "https://app.esemie.io/inventories/{id}/restock",
    androidIntent: true,
  },
};
